import api from "./api";

const getAll = (params) => {
  return api.get("/api/time-off", { params });
};

const getOne = (id) => {
  return api.get(`/api/time-off/${id}`);
};

const getConflictingWos = (id) => {
  return api.get(`/api/time-off/${id}/conflicting-wos`);
};

// status: 0 pending, 1 approved with PTO, 2 approved without PTO, 3 rejected
const updateStatus = (id, status, rejectionReason) => {
  const payload = { status };
  if (rejectionReason) payload.rejectionReason = rejectionReason;
  return api.patch(`/api/time-off/${id}`, payload);
};

const TimeOffService = {
  getAll,
  getOne,
  getConflictingWos,
  updateStatus,
};

export default TimeOffService;
